import React from "react";
import BeneficiariesDataTable from "./BeneficiariesDataTable";

const BeneficiariesPage = () => {
  return (
    <div className="sub-content">
      <BeneficiariesDataTable />
    </div>
  );
};

export default BeneficiariesPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/beneficiaries/BeneficiariesPage.js